const translation = {
  title: 'Explore',
  sidebar: {
    discovery: 'Discovery',
    chat: 'Chat',
    workspace: 'Workspace',
    action: {
      pin: 'Pin',
      unpin: 'Unpin',
      rename: 'Rename',
      delete: 'Delete',
    },
    delete: {
      title: 'Delete app',
      content: 'Are you sure you want to delete this app?',
    },
  },
  apps: {
    title: 'Explore Apps',
    description: 'Use these template apps instantly or customize your own apps based on the templates.',
    allCategories: 'Recommended',
  },
  appCard: {
    addToWorkspace: 'Add to Workspace',
    customize: 'Customize',
  },
  appCustomize: {
    title: 'Create app from {{name}}',
    subTitle: 'App icon & name',
    nameRequired: 'App name is required',
  },
  category: {
    Agent: 'Agent',
    Assistant: 'Assistant',
    Writing: 'Writing',
    Translate: 'Translate',
    Programming: 'Programming',
    HR: 'HR',
    Workflow: 'Workflow',
    Entertainment: 'Entertainment',
  },
}

export default translation
